// src/components/PaginatedTable.js
import React, { useState } from 'react';
import { Table, Pagination } from 'react-bootstrap';
import TableWrapper from './TableWrapper';

const PaginatedTable = ({
  data = [],
  columns = [],
  rowsPerPage = 50,
  renderRow,
  tableClassName = 'table table-striped table-hover'
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const currentRows = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <TableWrapper>
        <Table className={tableClassName} responsive>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={{ cursor: 'pointer' }}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((row, idx) => (
              <tr key={idx}>{renderRow(row, idx, currentPage - 1, rowsPerPage)}</tr>
            ))}
          </tbody>
        </Table>
      </TableWrapper>
      <Pagination className="justify-content-center">
        <Pagination.Prev
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {[...Array(totalPages)].map((_, idx) => {
          const pageNumber = idx + 1;
          return (
            <Pagination.Item
              key={pageNumber}
              active={pageNumber === currentPage}
              onClick={() => paginate(pageNumber)}
            >
              {pageNumber}
            </Pagination.Item>
          );
        })}
        <Pagination.Next
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </>
  );
};

export default PaginatedTable;
